import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router-dom";
import WrapperOrders from "../../../components/shared/WrapperContent";
import OrdersContent from "../../../components/orders/content";
import style from "./GuestOrderViewPage.module.scss";
import Loading from "../../../components/shared/Loading/Loading";
import EmptyContent from "../../../components/shared/emptyContent";
import { useIdleAutoRefresh } from "../../../hooks/useIdleAutoRefresh";
import OrderShareContent from "../../../components/orders-new/order-info/components/mobile/OrderShareContent";
import { configData } from "../../../services/api-config";

const GuestOrderViewPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { guestToken } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [routeData, setRouteData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);



  const fetchRoutes = async (cityFrom, cityTo) => {
    try {
      const response = await fetch(
        `${configData.BASE_URL}api/v1/routes?fromCityId=${cityFrom}&toCityId=${cityTo}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${guestToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRouteData(data);
      console.log("Routes data:", data);
    } catch (err) {
      console.error("Error fetching routes:", err);
    }
  };

  const fetchOrderByGuestToken = async (guestToken) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${configData.BASE_URL}api/v1/orders/order-by-guest-token`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${guestToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setOrderData(data);

      if (data.order?.cityIdFrom && data.order?.cityIdTo) {
        await fetchRoutes(data.order.cityIdFrom, data.order.cityIdTo);
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      setError(err.message);
      setOrderData([]);
    } finally {
      setLoading(false);
    }
  };

  const triggerRefresh = useCallback(() => {
    if (guestToken) {
      fetchOrderByGuestToken(guestToken);
    }
  }, [guestToken]);

  useIdleAutoRefresh(triggerRefresh, { idleTimeout: 60_000, refreshInterval: 300_000 });

  useEffect(() => {
    if (guestToken) {
      fetchOrderByGuestToken(guestToken);
    } else {
      setError("Token not found in URL");
      setLoading(false);
    }
  }, [location.pathname]);

  if (error) {
    return (
      <WrapperOrders>
        <OrdersContent>
          <div className="alert alert-warning text-center" role="alert">
            <strong>{t("common.warning")}</strong> Страница недоступна. Возможные причины:
            <ul className="text-left mt-2">
              <li>ссылка больше недействительна, так как заказ уже завершён;</li>
              <li>ссылка была указана с ошибкой или повреждена;</li>
              <li>срок действия ссылки истёк.</li>
            </ul>
            Чтобы продолжить, пожалуйста, запросите новую ссылку или повторите действие через личный кабинет.
          </div>
        </OrdersContent>
      </WrapperOrders>
    );
  }

  return (
    <>
      <OrdersContent>
        <div className={style.content}>
          {isLoading ? (
            <Loading inBlock />
          ) : !orderData && !isLoading ? (
            <EmptyContent />
          ) : (
            <OrderShareContent item={orderData} routeData={routeData} />
          )}
        </div>
      </OrdersContent>
    </>
  );
};

export default GuestOrderViewPage;
